import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, distinctUntilChanged, map, Observable, startWith } from 'rxjs';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { FiltrosExclusion, IBusqueda, ICategoriaAsignatura, IDescarga, IExclusionAsignaturaRes, ISeccion, ISedes, ISiglaAsignatura } from 'src/app/interfaces/exclusion-asignatura';
import { IListaPeriodos } from 'src/app/interfaces/utils';
import { ExclusionService } from 'src/app/services/exclusion-asignatura/exclusion-asignatura';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-view-config-exclusion-asignatura',
  templateUrl: './view-config-exclusion-asignatura.component.html',
  styleUrls: ['./view-config-exclusion-asignatura.component.scss']
})
export class ViewConfigExclusionAsignaturaComponent implements OnInit {
  dtOptions: DataTables.Settings | any = { ...DatatableConfig.dtExclusionAsignaturas };
  parametrosForm = this.formBuilder.group({
    anyo: ['0', [Validators.required]],
    periodo: ['0', [Validators.required]],
    sede: ['0'],
    tipoAsignatura: ['0', [Validators.required]],
    asignatura: ['', [Validators.required]],
    seccion: ['']
  })
  listaAnyos: Array<number> = []
  listaPeriodos: any = [];
  listaSedes: any = [];
  listaTipoAsignatura: any = [];
  listaAsignatura: any = [];
  listaSeccion: any = [];
  listaDatos: any = [];
  filtrosExclusion: FiltrosExclusion = new FiltrosExclusion();

  error: string = "";
  mensajeExito: string = "";
  textoModal: string = "";
  tituloModal: string = "";

  searchAsignaturaForm = new FormControl('')
  searchSeccionForm = new FormControl('');
  filteredAsignatura: Observable<Array<any>>
  filteredSeccion: Observable<Array<any>>;
  asignaturaSeleccionada: any = {};
  seccionSeleccionada: any = {};
  submitted: boolean = false;
  tieneErrores: any = {};
  tableRender: boolean = false;
  excluirTodos: boolean = false;
  filtrosBuscados: FiltrosExclusion = new FiltrosExclusion();
  rolDaraCentral: boolean = false
  listaDatosModificada: any = []

  currentTab: string = 'individual'
  mensajeExitoExclusionMasiva: string = ''
  mensajeErrorExclusionMasiva: string = ''
  excluir: boolean = true

  constructor(
    private utilsService: UtilsService,
    private spinner: NgxSpinnerService,
    private _perfilamiento: PerfilamientoService,
    private exclusionService: ExclusionService,
    private formBuilder: FormBuilder,
  ) {
    this.filteredAsignatura = this.searchAsignaturaForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "asignatura")),
    );
    this.filteredSeccion = this.searchSeccionForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "seccion")),
    )
    this.searchAsignaturaForm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    )
      .subscribe(res => {
        if (typeof res === 'object') {
          this.listaSeccion = [];
          let id = this.obtenerId(res);
          this.getListaSeccion(this.filtrosExclusion.sedeId, this.filtrosExclusion.tipoAsignaturaId, id);
        } else {
          this.listaSeccion = [];
          this.filteredSeccion = this.searchSeccionForm.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '', "seccion")),
          )
        }
      })

    const userData = this._perfilamiento.getUsuario()
    if (userData.nombreRol === 'R_DARA_C') {
      this.rolDaraCentral = true
    }
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtExclusionAsignaturas }
    this.getListaAnyos()
    this.getListaTipoAsignatura()
  }

  private _filter(value: string, solicitante: string): string[] {
    if (typeof value != 'string') {
      return [];
    }
    const filterValue = this._normalizeValue(value);
    if (solicitante == "asignatura") {
      return this.listaAsignatura.filter((asignatura: { id: number, codigo: string }) => this._normalizeValue(asignatura?.codigo)?.includes(filterValue));
    } else {
      return this.listaSeccion.filter((seccion: { id: number, codigo: string }) => this._normalizeValue(seccion?.codigo)?.includes(filterValue));
    }

  }

  private _normalizeValue(value: string): string {
    return value?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, '');
  }

  changeTab(tipo: string):void {
    this.currentTab = tipo
  }

  getListaAnyos() {
    this.utilsService.obtenerListaAnhos().subscribe(
      (res: any) => {
        if (res.error != null) {
          this.error = res.error;
          this.limpiarMensajes();
        } else {
          this.listaAnyos = res.anyos;
        }
      }
    )
  }

  getListaSedes() {
    let user = this._perfilamiento.getUsuario();
    let userId = user.usuarioId;
    if (this.filtrosExclusion.anyo != 0 && this.filtrosExclusion.periodoId != 0) {
      this.exclusionService.getSedes(userId, this.filtrosExclusion.anyo, this.filtrosExclusion.periodoId).subscribe(
        {
          next: (res: ISedes) => {
            this.listaSedes = res.sedes;
          }
        }
      );
    }
  }

  getListaPeriodos(): void {
    if (this.filtrosExclusion.anyo != 0) {
      this.filtrosExclusion.periodoId = 0;
      this.utilsService.obtenerListaPeriodos(this.filtrosExclusion.anyo).subscribe({
        next: (res: IListaPeriodos) => {
          this.listaPeriodos = res.periodos;
        },
        error: error => {
          this.limpiarMensajes();
        }
      })
    }
  }

  getListaTipoAsignatura(sedeId?: number): void {
    this.filtrosExclusion.tipoAsignaturaId = 0;
    this.filtrosExclusion.asignaturaId = 0;
    this.listaTipoAsignatura = [];
    this.listaAsignatura = [];
    this.searchAsignaturaForm.setValue("");
    this.searchSeccionForm.setValue("");

    this.exclusionService.getCategoriasAsignatura().subscribe({
      next: (res: ICategoriaAsignatura) => {
        this.listaTipoAsignatura = res.categoriaAsignaturaDTOList;
      }
    })
  }
  getListaAsignatura(sedeId: number, tpoAsignaturaId: number): void {
    if (this.filtrosExclusion.anyo != 0 && this.filtrosExclusion.periodoId != 0) {
      this.filtrosExclusion.asignaturaId = 0;
      this.filtrosExclusion.seccionId = 0;
      this.listaAsignatura = [];
      this.listaSeccion = [];

      this.searchAsignaturaForm.setValue("");
      this.searchSeccionForm.setValue("");
      this.exclusionService.getSiglasAsignatura(this.filtrosExclusion.anyo, this.filtrosExclusion.periodoId, sedeId, tpoAsignaturaId).subscribe({
        next: (res: ISiglaAsignatura) => {
          this.listaAsignatura = res.asignaturas;
          this.filteredAsignatura = this.searchAsignaturaForm.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '', "asignatura")),
          );
        }
      })
    }
  }
  getListaSeccion(sedeId: number, tpoAsignaturaId: number, asignaturaId: number): void {

    if (this.filtrosExclusion.anyo != 0 && this.filtrosExclusion.periodoId != 0) {
      this.listaSeccion = [];
      this.filtrosExclusion.seccionId = 0;
      this.searchSeccionForm.setValue("");
      this.exclusionService.getSeccion(this.filtrosExclusion.anyo, this.filtrosExclusion.periodoId, sedeId, tpoAsignaturaId, asignaturaId).subscribe({
        next: (res: ISeccion) => {
          this.listaSeccion = res.secciones;
          this.filteredSeccion = this.searchSeccionForm.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '', "seccion")),
          );
        }
      })
    }
  }

  obtenerId(objeto: any): number {
    return objeto.id;
  }

  filtrosConError(): boolean {
    let error = false;
    if (typeof this.searchAsignaturaForm.value === 'object') {
      this.filtrosExclusion.asignaturaId = this.obtenerId(this.searchAsignaturaForm.value)
    } else {
      this.filtrosExclusion.asignaturaId = 0;
    }
    if (typeof this.searchSeccionForm.value === 'object') {
      this.filtrosExclusion.seccionId = this.obtenerId(this.searchSeccionForm.value)
    } else {
      this.filtrosExclusion.seccionId = 0;
    }
    if (this.filtrosExclusion.anyo == 0) {
      this.tieneErrores['anyo'] = true;
      error = true;
    }
    if (this.filtrosExclusion.periodoId == 0) {
      this.tieneErrores["periodo"] = true;
      error = true;
    }
    if (this.filtrosExclusion.tipoAsignaturaId == 0) {
      this.tieneErrores["tipoAsignatura"] = true;
      error = true;
    }

    if ( this.currentTab === 'individual' && this.filtrosExclusion.asignaturaId == 0 && this.filtrosExclusion.sedeId == 0 ) {
      this.tieneErrores["asignatura"] = true;
      this.tieneErrores["sede"] = true;
      error = true;
    }
    if ( this.currentTab === 'individual' && (this.filtrosExclusion.asignaturaId != 0 || this.filtrosExclusion.sedeId != 0) ) {
      delete this.tieneErrores.asignatura
      delete this.tieneErrores.sede
    }
    if (!this.rolDaraCentral && this.filtrosExclusion.sedeId == 0) {
      this.tieneErrores["sede"] = true;
      error = true;
    }
    return error
  }

  buscarExclusionAsignaturas(): void {
    this.tableRender = false;
    this.submitted = true;
    let error = this.filtrosConError()

    if (!error) {
      this.listaDatos = [];
      let controlCambiosFiltroExclusion: any = { ...this.filtrosExclusion }
      delete controlCambiosFiltroExclusion.tipoAsignaturaId
      controlCambiosFiltroExclusion.catAsignaturaId = this.filtrosExclusion.tipoAsignaturaId
      this.exclusionService.postBusquedaExclusion(controlCambiosFiltroExclusion).subscribe({
        next: (res: IBusqueda[]) => {
          this.listaDatos = res;
          let datosIncluidos = true;
          this.listaDatos.forEach((dato: any) => {
            if (!dato.excluir) {
              datosIncluidos = false;
            }
          })
          this.excluirTodos = datosIncluidos;
          this.tableRender = true;
          this.filtrosBuscados = this.filtrosExclusion;
        },
        error: error => {
          this.limpiarMensajes();
        }
      })
    }
  }

  modalConfirmarExclusionMasiva(excluir: boolean) {
    this.excluir = excluir
    this.submitted = true
    let error = this.filtrosConError()
    if ( !error ) {
      document.getElementById('btn-trigger-modal-exclusion-masiva')?.click()
    }
  }

  exclusionAsignaturas(excluir: boolean): void {
    this.submitted = true
    let error = this.filtrosConError()

    if (!error) {
      let controlCambiosFiltroExclusion: any = { ...this.filtrosExclusion }
      delete controlCambiosFiltroExclusion.tipoAsignaturaId
      controlCambiosFiltroExclusion.catAsignaturaId = this.filtrosExclusion.tipoAsignaturaId // descCatAsignaturaId
      controlCambiosFiltroExclusion.excluir = excluir
      this.exclusionService.postExclusionMasiva(controlCambiosFiltroExclusion).subscribe(
        (res: IExclusionAsignaturaRes) => {
          if ( res.error !== null ) {
            this.mensajeErrorExclusionMasiva = res.error?.mensaje ?? 'Hubo un error en los servicios.'
          } else {
            this.mensajeExitoExclusionMasiva = `Se ha ${excluir ? 'excluido' : 'incluido'} por filtro de manera exitosa.`
          }
          setTimeout(() => {
            this.mensajeErrorExclusionMasiva = '';
            this.mensajeExitoExclusionMasiva = '';
          }, 15000);
        }
      )
    }
  }

  limpiarMensajes() {
    setTimeout(() => {
      this.error = '';
      this.mensajeExito = "";
    }, 15000);
  }
  limpiarFiltros(): void {
    this.filtrosExclusion = new FiltrosExclusion();
    this.listaAsignatura = [];
    this.listaPeriodos = [];
    this.listaSeccion = [];
    this.searchAsignaturaForm.setValue("");
    this.searchSeccionForm.setValue("");
    this.resetearValidacion();
    this.tableRender = false;
    this.listaDatos = [];
  }
  resetearValidacion() {
    this.submitted = false;
    this.tieneErrores["anyo"] = false;
    this.tieneErrores["periodo"] = false;
    this.tieneErrores["sede"] = false;
    this.tieneErrores["tipoAsignatura"] = false;
    this.tieneErrores["asignatura"] = false;
  }
  displayFnAsignatura(asignatura: any): string {
    return asignatura?.codigo ? asignatura.codigo.replace(/\w\S*/g, (w: string) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '';
  }
  displayFnSeccion(seccion: any): string {
    return seccion?.codigo ?? '';
  }
  modalConfirmacion(): void {
    if (this.excluirTodos) {
      this.tituloModal = "¿Estás seguro/a que deseas incluir todas las asignaturas?"
      this.textoModal = "Al presionar el botón Si, todas las exclusiones vigentes de las asignaturas quedarán desactivadas y se modificaran automáticamente.";
      $("#btn-modal").trigger("click");
    } else {
      this.tituloModal = "¿Estás seguro/a que deseas excluir todas las asignaturas?"
      this.textoModal = "Al presionar el botón Si, todas las asignaturas quedarán excluidas y se modificaran automáticamente.";
      $("#btn-modal").trigger("click");
    }
  }
  exclusionMasiva(valor: boolean): void {
    this.excluirTodos = valor;
    let fechaActual = new Date()
    const fechaFormateada = formatDate(fechaActual, 'dd/MM/YYYY HH:mm', 'en-US')
    this.listaDatos.forEach((dato: any) => {
      dato.excluir = valor;
      dato.fecha = fechaFormateada
    });
    this.listaDatosModificada = this.listaDatos
    this.guardar();
  }
  descargarDatos(): void {
    if (this.listaDatos.length == 0) {
      this.error = "No existen datos para descargar";
      this.limpiarMensajes();
    } else {
      let controlCambiosFiltroExclusion: any = { ...this.filtrosBuscados }
      delete controlCambiosFiltroExclusion.tipoAsignaturaId
      controlCambiosFiltroExclusion.catAsignaturaId = this.filtrosBuscados.tipoAsignaturaId
      this.exclusionService.postDescargarExclusion(controlCambiosFiltroExclusion).subscribe({
        next: (res: IDescarga) => {
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarMensajes();
          } else {
            let codigoPeriodo = 0;
            this.listaPeriodos.find((periodo: any) => {
              if (periodo.periodoAcademicoId == this.filtrosBuscados.periodoId) {
                codigoPeriodo = periodo.codigoPeriodo;
              }
            })
            const bstr = atob(res.archivo);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            const file = new File([u8arr], "exclusiónAsignaturas-" + this.filtrosBuscados.anyo + "_" + codigoPeriodo, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let link = document.createElement('a');

            //Adicionar y descargar el archivo
            link.href = window.URL.createObjectURL(file);
            link.download = "exclusiónAsignaturas-" + this.filtrosBuscados.anyo + "_" + codigoPeriodo;
            link.click();
            this.mensajeExito = "El archivo se ha generado con éxito.";
            this.limpiarMensajes();
          }
        },
        error: error => {
          this.limpiarMensajes();
        }
      })
    }
  }

  modificacionDato(dato: any) {
    const usuario = this._perfilamiento.getUsuario()
    let fechaActual = new Date()
    const fechaFormateada = formatDate(fechaActual, 'dd/MM/YYYY HH:mm', 'en-US')
    dato.fecha = fechaFormateada
    dato.usuario = usuario.username

    if (this.listaDatosModificada.length > 0) {
      let index = this.listaDatosModificada.findIndex((x: any) =>
        x.idSeccion == dato.idSeccion);

      if (index == -1) {
        this.listaDatosModificada.push(dato)
      } else {
        this.listaDatosModificada = this.listaDatosModificada.filter((x: any) =>
          x.idSeccion != dato.idSeccion);
      }
    } else {
      this.listaDatosModificada.push(dato)
    }
  }

  guardar(): void {
    if (this.listaDatos.length == 0) {
      this.error = "No existen datos para guardar.";
      this.limpiarMensajes();
    } else {
      this.exclusionService.postGuardarExclusionAsignaturas(this.listaDatosModificada).subscribe(
        (res: any) => {
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarMensajes();
          } else {
            this.mensajeExito = "Se han guardado los cambios con éxito.";
            this.listaDatosModificada = []
            this.buscarExclusionAsignaturas()
            this.limpiarMensajes();
          }
        }
      )
    }
  }
}
